import { useEffect, useState } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import { ToastService } from '@core';
import { useOnlineStatus } from '@utils';

import { OFFLINE_MESSAGE_ID } from '../../../App.constant';

const useErrorBoundaryService = () => {
  const { isOnline } = useOnlineStatus();
  const error = useRouteError();
  const [wasOffline] = useState(!isOnline);

  const errorMessage =
    error instanceof Error ? error.message : JSON.stringify(error);

  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : errorMessage;

  const stack = error instanceof Error ? error.stack : null;

  useEffect(() => {
    ToastService.Dismiss(OFFLINE_MESSAGE_ID);
    if (wasOffline && isOnline) window.location.reload();
  }, [isOnline]);

  return { isOnline, wasOffline, stack, message };
};

export default useErrorBoundaryService;
